import { Component } from '@angular/core'
import { Select } from '@ngxs/store'
import { Observable } from 'rxjs'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'
import { DialogService } from 'primeng/dynamicdialog'
import { CloseComponent } from '../../dialogs/close/close.component'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-test',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
})
export class WizardComponent {
  @Select(state => state.plugplay?.isActive)
  public isActive$: Observable<number>
  @Select(state => state.plugplay?.highestLastStepCompleted)
  public highestLastStepCompleted$: Observable<number>
  @Select(state => state.plugplay?.highestStepVisited)
  public highestStepVisited$: Observable<number>
  @Emitter(PlugplayState.setWizardVisibility)
  public readonly setWizardVisibility: Emittable<boolean>
  public readonly conf: Array<{ i18nKey: string; routerLink: Array<string> }> = [
    { i18nKey: 'wizard.menu.introduction', routerLink: ['./step-1'] },
    { i18nKey: 'wizard.menu.depots-checkouts', routerLink: ['./step-2'] },
    { i18nKey: 'wizard.menu.users', routerLink: ['./step-3/list'] },
    { i18nKey: 'wizard.menu.suppliers', routerLink: ['./step-4'] },
    { i18nKey: 'wizard.menu.import-products', routerLink: ['./step-5'] },
    { i18nKey: 'wizard.menu.product-move-pack', routerLink: ['./step-6'] },
    { i18nKey: 'wizard.menu.data-clarity-check', routerLink: ['./step-7/check'] },
    { i18nKey: 'wizard.menu.completion', routerLink: ['./step-8'] },
  ]

  constructor(
    public readonly dialogService: DialogService,
    public readonly router: Router,
    private translateService: TranslateService,
  ) {}

  close() {
    this.dialogService
      .open(CloseComponent, {
        header: this.translateService.instant('wizard.close-dialog.title'),
      })
      .onClose.subscribe((shouldBeClosed: boolean) => {
        if (shouldBeClosed) {
          this.setWizardVisibility.emit(false)
          this.router.navigate(['/home'])
        }
      })
  }
}
